import './App.css';
import Navbar from './components/Navbar';
import SwiperSlider from './components/SwiperSlider';
import ProgrammesList from './components/ProgrammeList';
import FlipCards from './components/FlipCards';
import Cards from './components/Cards';
import WhyChooseUs from './components/WhyChooseUs';
import BenefitSection from './components/BenifitSection';
import SliderSection from './components/SliderSection';
import ServicesSection from './components/ServiceSection';
import StepsSection from './components/Overlapping';
import AdvantagesSection from './components/Advantages';
import AboutUsSection from './components/AboutUsSection';
import ContactForm from './components/ContactForm';
import ContactDetailsSection from './components/ContactDetail';
import FooterSection from './components/FooterSection';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function HomePage() {
  return (
    <>
      <SwiperSlider />
      <ProgrammesList />
      <FlipCards />
      <Cards />
      <SliderSection />
      <WhyChooseUs />

      <BenefitSection />
      <ServicesSection />
      
      <StepsSection />
      <AdvantagesSection />
      <AboutUsSection />
      <ContactForm />
      <ContactDetailsSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/whychooseus" element={<WhyChooseUs />} />
        <Route path="/services" element={<ServicesSection />} />
        <Route path="/about" element={<AboutUsSection />} />
        <Route path="/contact" element={<ContactForm />} />
      </Routes>

      <FooterSection />
    </Router>
  );
}

export default App;
